module.exports = __webpack_public_path__ + "img/tp1.bb2f1a65.png";